import AssetCardGridContainer from './AssetCardGrid';

export default AssetCardGridContainer;
